module.exports = __webpack_public_path__ + "media/images/product_lines/car/info2-a233b5b7ed869590e7df396c5ea0e428.svg";